
<div class="wrapper">
  <section id="esqueci-senha">
    <div class="container area-faca-parte" *ngIf="!requestSend && !hasToken">
      <form class="sample-form" method="post" target="_top" [formGroup]="form">
        <div class="body-faca-parte columns">
          <div class="column is-full">
            
            <div class="dados-pessoais text-center">

              <h3>ESQUECI MINHA SENHA</h3>
              <p>Para recuperar sua senha, basta inserir seu e-mail ou CPF vinculado à sua assinatura.</p>
              <div class="field forms-dados" tabindex="1">
                <label class="email" name="email">E-mail ou CPF</label>
                <input name="email" type="text" placeholder="E-mail ou CPF" formControlName="value" [class]="fieldCss(form, 'value')" required>
                <span class="campo-erro" *ngIf="showError(form,'value')">{{getErrorMessage(form,'value')}}</span>
                <span class="campo-erro" *ngIf="errorCpf || errorEmail">CPF ou E-mail inválido</span>
                <span class="campo-erro" *ngIf="requestError">
                  Ops! Não encontramos o e-mail ou CPF informado em nossa base de dados. Neste caso, Insira Outro E-mail ou CPF ou Continue seu Cadastro Agora!
                </span>
              </div>

              <div class="captcha" tabindex="1">
                <ngx-recaptcha2 #captchaElem
                                [siteKey]="siteKey"
                                (success)="handleSuccess($event)"
                                [size]="size"
                                [hl]="lang"
                                [theme]="theme"
                                [type]="type"
                                [useGlobalDomain]="false"
                                formControlName="recaptcha"></ngx-recaptcha2>
              </div>

              <button (click)="submit()" type="submit" [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'" [disabled]="form.invalid" class="btn-mobile">
                RECUPERAR MINHA SENHA
              </button>

            </div>
          </div>
        </div>
        
      </form>
    </div>
    <div class="container area-faca-parte" *ngIf="requestSend && !hasToken">
      <form class="sample-form" method="post" target="_top" [formGroup]="form">
        <div class="body-faca-parte columns">
          <div class="column is-full">
            <div class="dados-pessoais text-center">
              <div class="aviso-sucesso" *ngIf="!requestError">
                <h3>ENCONTREI SEU CADASTRO!</h3>
                <div>
                  <p>Enviamos uma nova senha para o e-mail e celular cadastrado na assinatura.</p>
                  <p>Dá uma olhadinha na caixa de entrada e SMS!</p>
                  <p>Se não encontrar o e-mail, verifique sua caixa de SPAM</p>
                </div>
                <br>
                <a  style="text-decoration: underline!important; color: #0f81cc;" href="/login">Voltar para o Login</a>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="container area-faca-parte" *ngIf="hasToken && !requestChancePasswordSend">
      <form class="sample-form" method="post" target="_top" [formGroup]="formChangePassword">
        <div class="body-faca-parte columns">
          <div class="column is-full">

            <div class="dados-pessoais text-center">

              <h3>ALTERAR SENHA</h3>
              <p>A senha deve conter 4 números.</p>
              <div class="field forms-dados" tabindex="1">
                <label class="email" name="password">Senha</label>
                <input name="password"
                       type="password"
                       placeholder="Senha"
                       formControlName="password"
                       [class]="fieldCss(formChangePassword, 'password')"
                       maxlength="4"
                       (keypress)="omitSpecialChar($event)"
                       required>
                <span class="campo-erro" *ngIf="showError(formChangePassword,'password')">{{getErrorMessage(formChangePassword,'password')}}</span>
              </div>

              <div class="field forms-dados" tabindex="1">
                <label class="email" name="confirmPassword">Confirmação de Senha</label>
                <input name="confirmPassword"
                       type="password"
                       placeholder="Confirmação de Senha"
                       formControlName="confirmPassword"
                       [class]="fieldCss(formChangePassword, 'confirmPassword')"
                       (ngModelChange)="verifyPassword()"
                       maxlength="4"
                       (keypress)="omitSpecialChar($event)"
                       required>
                <span class="campo-erro" *ngIf="showError(formChangePassword,'confirmPassword')">{{getErrorMessage(formChangePassword,'confirmPassword')}}</span>
              </div>

              <button (click)="submitAlterPassword()" type="submit" [class]="formChangePassword.invalid ? 'btn-desabilitado' : 'btn-verde'" [disabled]="formChangePassword.invalid" class="btn-mobile">
                ALTERAR
              </button>

            </div>
          </div>
        </div>

      </form>
    </div>
    <div class="container area-faca-parte" *ngIf="hasToken && requestChancePasswordSend">
      <form class="sample-form" method="post" target="_top" [formGroup]="form">
        <div class="body-faca-parte columns">
          <div class="column is-full">
            <div class="dados-pessoais text-center">
              <div class="aviso-sucesso" *ngIf="!requestError">
                <div class="text-center">
                <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                <h2>OBRIGADO!</h2>
              </div>
                <h3>Senha Alterada com Sucesso!</h3>
                <a  style="text-decoration: underline!important; color: #0f81cc;" href="/login">Voltar para o Login</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>

</div>


